module.exports = __webpack_public_path__ + "pnskfsquadron/img/tw-slider-3.jpg?cf576f6f";